import React from 'react';

import { Space } from 'antd-v5';
import { FormattedMessage } from 'react-intl';
import { Button, Text } from 'scouting-ui/lib';

import styles from './ImportStats.module.scss';

interface ImportStatsProps {
  uploadedCount: number;
  onNavigateToHistory: () => void;
}

/** Presentational summary + link to the History tab (mirrors legacy UploadStats). */
const ImportStats: React.FC<ImportStatsProps> = props => {
  const { uploadedCount, onNavigateToHistory } = props;

  return (
    <div className={styles.container}>
      <Text font="body-body-2" color="color-white">
        {uploadedCount > 0 ? (
          <FormattedMessage
            id="advancementImport.uploads"
            values={{ count: uploadedCount }}
          />
        ) : (
          <FormattedMessage id="advancementImport.noUploads" />
        )}
      </Text>
      <Space direction="vertical" size={0}>
        <Text font="body-caption" color="color-white">
          <FormattedMessage id="advancementImport.processedHourly" />
        </Text>
        <Text font="body-caption" color="color-white">
          <FormattedMessage id="advancementImport.visitTab" />
        </Text>
      </Space>
      <Button
        type="default"
        size="small"
        className={styles.checkButton}
        onClick={onNavigateToHistory}
      >
        <FormattedMessage id="advancementImport.checkLog" />
      </Button>
    </div>
  );
};

export default ImportStats;
